import { fetchWithToken } from '../auth';
import { sendClientLog } from 'services/logService';

export function postWithToken(url, data) {
  return fetchWithToken(url, {
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  })
    .then(handleErrors);
}

export function postWithTokenNoErrorLog(url, data) {
  return fetchWithToken(url, {
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  }, false, 0) // In case the log request fails- Pass false to prevent a new log of the first log failure, 0 to prevent retries of the first request
    .then(handleErrorsNoLog);
}

export function getWithToken(url) {
  return fetchWithToken(url)
    .then(handleErrors);
}


export function putWithToken(url, data) {
  return fetchWithToken(url, {
    //return fetch(url, {
    method: 'put',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  })
    .then(handleErrors);
}
export function patchWithToken(url, data) {
  return fetchWithToken(url, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  })
    .then(handleErrors);
}
export function deleteWithToken(url, data) {
  return fetchWithToken(url, {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  })
    .then(handleErrors);
}

const handleErrors = (response) => { // Catches nonsuccessful responses from the API. Errors from AD (that never make it to API) handled in auth/index.js
  if (response && !response.ok) {
    return response.text()
      .then(text => {
        if (text) {
          // console.log(`Client API - response error`, text)
          sendClientLog('Error', `Client API - response error: ${text} | Requested url: ${response.url}`) // Log the response
          throw new Error(text);
        }
        else {
          sendClientLog('Error', `Client API - Unable to get response error text | Requested url: ${response.url}`) // Log the response
          throw Error('Oops! Something unexpected happened!'); // Throw error to be caught by function that made the request
        }
      });
  }
  return response;
}

const handleErrorsNoLog = (response) => { // Used by requests made by sendClientLog- in case API responds nonsuccessful to that request, don't send another log to prevent infinite loop
  if (response && !response.ok) {
    return response.text()
      .then(text => {
        if (text) throw new Error(text);
        else throw Error('Oops! Something unexpected happened!');
      });
  }
  return response;
}



export function getWithTokenV2(url) {
  return fetchWithToken(url).then(handleResponse);
}

export function postWithTokenV2(url, data) {
  return fetchWithToken(url, {
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  })
    .then(handleResponse);
}

export function putWithTokenV2(url, data) {
  return fetchWithToken(url, {
    //return fetch(url, {
    method: 'put',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  })
    .then(handleResponse);
}

const handleResponse = (response) => {
  if(response && response.ok){
    return response.json().then(apiResponseDto => {          
      if(apiResponseDto.status === 'success'){
        return apiResponseDto.data;
      }
      else {
        if(apiResponseDto.error){
          if(apiResponseDto.error.details) {
            throw apiResponseDto.error;
          }
          else{
            throw new Error(apiResponseDto.error.message);
          }
        }
        else{
          sendClientLog('Error', `Client API - API response status is not success but error object is also empty | Requested url: ${response.url}`) // Log the response
          throw Error('Oops! Something unexpected happened!'); // Throw error to be caught by function that made the request
        }
      }
    });
  }
  else{
    return response.text()
    .then(text => {
      if (text) {
        sendClientLog('Error', `Client API - response error: ${text} | Requested url: ${response.url}`) // Log the response
        throw new Error(text);
      }
      else {
        sendClientLog('Error', `Client API - Unable to get response error text | Requested url: ${response.url}`) // Log the response
        throw Error('Oops! Something unexpected happened!'); // Throw error to be caught by function that made the request
      }
    });
  }
}
